// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IUz_Eo1OmrUDl6tLFvvj {
  overflow-wrap: break-word;
}

.IUz_Eo1OmrUDl6tLFvvj h1,
.IUz_Eo1OmrUDl6tLFvvj h2,
.IUz_Eo1OmrUDl6tLFvvj h3,
.IUz_Eo1OmrUDl6tLFvvj h4 {
  margin-bottom: 0.5rem;
  line-height: 2;
  font-family: "GmarketSansMedium";
  scroll-margin-top: 1.5rem;
}

.IUz_Eo1OmrUDl6tLFvvj h1 {
  font-size: 1.5rem;
  margin-top: 3rem;
}

.IUz_Eo1OmrUDl6tLFvvj h2 {
  font-size: 1.25rem;
  margin-top: 2.5rem;
}

.IUz_Eo1OmrUDl6tLFvvj h2::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 0.9em;
  margin-right: 0.5rem;
  vertical-align: -0.1em;
  border-radius: 2px;
  background: #ffb86b;
}

.IUz_Eo1OmrUDl6tLFvvj h3 {
  font-size: 1.1rem;
  margin-top: 1.75rem;
}

.IUz_Eo1OmrUDl6tLFvvj h4 {
  font-size: 1rem;
  margin-top: 1.25rem;
}

/* 모바일에서 더 작은 간격 */
@media (max-width: 768px) {
  .IUz_Eo1OmrUDl6tLFvvj h1,
  .IUz_Eo1OmrUDl6tLFvvj h2,
  .IUz_Eo1OmrUDl6tLFvvj h3,
  .IUz_Eo1OmrUDl6tLFvvj h4 {
    margin-top: 0.8rem;
    margin-bottom: 0.3rem;
  }

  .IUz_Eo1OmrUDl6tLFvvj h1 {
    font-size: 1.3rem;
    margin-top: 2.25rem;
  }

  .IUz_Eo1OmrUDl6tLFvvj h2 {
    font-size: 1.15rem;
    margin-top: 2rem;
  }

  .IUz_Eo1OmrUDl6tLFvvj h3 {
    font-size: 1rem;
    margin-top: 1.5rem;
  }

  .IUz_Eo1OmrUDl6tLFvvj h4 {
    font-size: 0.9rem;
    margin-top: 1rem;
  }
}

.IUz_Eo1OmrUDl6tLFvvj p {
  margin-bottom: 0.8rem;
  line-height: 1.7;
}

.IUz_Eo1OmrUDl6tLFvvj ul {
  padding-left: 1.5rem;
  margin-bottom: 0.8rem;
  list-style-position: outside;
  list-style-type: disc;
  line-height: 1.7;
}

.IUz_Eo1OmrUDl6tLFvvj ol {
  padding-left: 1.5rem;
  margin-bottom: 0.8rem;
  list-style-position: outside;
  list-style-type: decimal;
  line-height: 1.7;
}

.IUz_Eo1OmrUDl6tLFvvj li {
  margin-bottom: 0.3rem;
  line-height: 1.7;
}

.IUz_Eo1OmrUDl6tLFvvj a {
  color: #ffb86b;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.IUz_Eo1OmrUDl6tLFvvj code {
  background: hsla(44, 6%, 50%, 0.15);
  font-size: 0.8rem;
  color: #ffb86b;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
}

.IUz_Eo1OmrUDl6tLFvvj pre {
  background-color: rgb(41, 41, 41);
  color: rgb(230, 230, 230);
  margin: 1rem 0;
  border-radius: 0.25rem;
  overflow-x: auto;
  white-space: pre;
  overflow-wrap: normal;
}

.IUz_Eo1OmrUDl6tLFvvj pre code {
  background: none;
  color: inherit;
  padding: 0;
  border-radius: 0;
}

.IUz_Eo1OmrUDl6tLFvvj blockquote {
  border-left: 0.2rem solid rgb(67, 67, 73);
  margin-left: 0;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  color: rgb(150, 150, 150);
  margin-bottom: 0.8rem;
  line-height: 1.6;
}

.IUz_Eo1OmrUDl6tLFvvj img {
  max-width: 100%;
  height: auto;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.IUz_Eo1OmrUDl6tLFvvj .TqbkeJ6xq1yJ0j4cO4X7 {
  overflow-x: auto;
  margin-bottom: 0.8rem;
}

.IUz_Eo1OmrUDl6tLFvvj table {
  width: 100%;
  border-collapse: collapse;
  line-height: 1.6;
}

.IUz_Eo1OmrUDl6tLFvvj th,
.IUz_Eo1OmrUDl6tLFvvj td {
  border: 1px solid rgb(67, 67, 73);
  padding: 0.5rem;
  text-align: left;
  line-height: 1.6;
}

.IUz_Eo1OmrUDl6tLFvvj th {
  background-color: rgb(51, 51, 51);
  font-family: "GmarketSansMedium";
  font-weight: normal;
  line-height: 1.6;
  color: rgb(230, 230, 230);
}

.IUz_Eo1OmrUDl6tLFvvj hr {
  border: 0;
  border-top: 0.0625rem solid rgb(67, 67, 73);
  margin: 1rem 0;
}

.IUz_Eo1OmrUDl6tLFvvj strong {
  font-family: "GmarketSansMedium";
}
`, "",{"version":3,"sources":["webpack://./src/styles/markdown-style.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE;;;;IAIE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".markdown {\n  overflow-wrap: break-word;\n}\n\n.markdown h1,\n.markdown h2,\n.markdown h3,\n.markdown h4 {\n  margin-bottom: 0.5rem;\n  line-height: 2;\n  font-family: \"GmarketSansMedium\";\n  scroll-margin-top: 1.5rem;\n}\n\n.markdown h1 {\n  font-size: 1.5rem;\n  margin-top: 3rem;\n}\n\n.markdown h2 {\n  font-size: 1.25rem;\n  margin-top: 2.5rem;\n}\n\n.markdown h2::before {\n  content: \"\";\n  display: inline-block;\n  width: 3px;\n  height: 0.9em;\n  margin-right: 0.5rem;\n  vertical-align: -0.1em;\n  border-radius: 2px;\n  background: #ffb86b;\n}\n\n.markdown h3 {\n  font-size: 1.1rem;\n  margin-top: 1.75rem;\n}\n\n.markdown h4 {\n  font-size: 1rem;\n  margin-top: 1.25rem;\n}\n\n/* 모바일에서 더 작은 간격 */\n@media (max-width: 768px) {\n  .markdown h1,\n  .markdown h2,\n  .markdown h3,\n  .markdown h4 {\n    margin-top: 0.8rem;\n    margin-bottom: 0.3rem;\n  }\n\n  .markdown h1 {\n    font-size: 1.3rem;\n    margin-top: 2.25rem;\n  }\n\n  .markdown h2 {\n    font-size: 1.15rem;\n    margin-top: 2rem;\n  }\n\n  .markdown h3 {\n    font-size: 1rem;\n    margin-top: 1.5rem;\n  }\n\n  .markdown h4 {\n    font-size: 0.9rem;\n    margin-top: 1rem;\n  }\n}\n\n.markdown p {\n  margin-bottom: 0.8rem;\n  line-height: 1.7;\n}\n\n.markdown ul {\n  padding-left: 1.5rem;\n  margin-bottom: 0.8rem;\n  list-style-position: outside;\n  list-style-type: disc;\n  line-height: 1.7;\n}\n\n.markdown ol {\n  padding-left: 1.5rem;\n  margin-bottom: 0.8rem;\n  list-style-position: outside;\n  list-style-type: decimal;\n  line-height: 1.7;\n}\n\n.markdown li {\n  margin-bottom: 0.3rem;\n  line-height: 1.7;\n}\n\n.markdown a {\n  color: #ffb86b;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.markdown code {\n  background: hsla(44, 6%, 50%, 0.15);\n  font-size: 0.8rem;\n  color: #ffb86b;\n  padding: 0.125rem 0.25rem;\n  border-radius: 0.25rem;\n}\n\n.markdown pre {\n  background-color: rgb(41, 41, 41);\n  color: rgb(230, 230, 230);\n  margin: 1rem 0;\n  border-radius: 0.25rem;\n  overflow-x: auto;\n  white-space: pre;\n  overflow-wrap: normal;\n}\n\n.markdown pre code {\n  background: none;\n  color: inherit;\n  padding: 0;\n  border-radius: 0;\n}\n\n.markdown blockquote {\n  border-left: 0.2rem solid rgb(67, 67, 73);\n  margin-left: 0;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  color: rgb(150, 150, 150);\n  margin-bottom: 0.8rem;\n  line-height: 1.6;\n}\n\n.markdown img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 0.25rem;\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n\n.markdown .tableWrapper {\n  overflow-x: auto;\n  margin-bottom: 0.8rem;\n}\n\n.markdown table {\n  width: 100%;\n  border-collapse: collapse;\n  line-height: 1.6;\n}\n\n.markdown th,\n.markdown td {\n  border: 1px solid rgb(67, 67, 73);\n  padding: 0.5rem;\n  text-align: left;\n  line-height: 1.6;\n}\n\n.markdown th {\n  background-color: rgb(51, 51, 51);\n  font-family: \"GmarketSansMedium\";\n  font-weight: normal;\n  line-height: 1.6;\n  color: rgb(230, 230, 230);\n}\n\n.markdown hr {\n  border: 0;\n  border-top: 0.0625rem solid rgb(67, 67, 73);\n  margin: 1rem 0;\n}\n\n.markdown strong {\n  font-family: \"GmarketSansMedium\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdown": `IUz_Eo1OmrUDl6tLFvvj`,
	"tableWrapper": `TqbkeJ6xq1yJ0j4cO4X7`
};
export default ___CSS_LOADER_EXPORT___;
